// extracted by mini-css-extract-plugin
export default {"toggler":"SearchToggle_toggler__FrFda","icon":"SearchToggle_icon__Q4KEn"};